// FILE GENERATO AUTOMATICAMENTE da scripts/genera-versione.js
// Non modificare a mano: viene riscritto ad ogni build/start.
export const VERSIONE = "0.1.43";
export const DATA_BUILD = "2026-10-26";
export const COMMIT = "3f9ae62";
